import { Component, OnInit, WritableSignal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    CeButtonComponent,
    CeIconComponent,
    CeSkeletonLoaderImports,
} from '@kempower-nx-workspace/shared/kp-design-system';
import { FoundReceiptComponent } from '../../ui/found-receipt/found-receipt.component';
import { NotFoundReceiptComponent } from '../../ui/not-found-receipt/not-found-receipt.component';
import { ReceiptSearchService, SearchResult } from '../../data-access/receipt-search.service';
import { ReceiptLookupNavigationService } from '@kempower-nx-workspace/receipt-lookup-app-core';

@Component({
    selector: 'lib-receipt-lookup-results',
    imports: [
        CommonModule,
        CeButtonComponent,
        CeIconComponent,
        FoundReceiptComponent,
        CeSkeletonLoaderImports,
        NotFoundReceiptComponent,
    ],
    templateUrl: './receipt-lookup-results.component.html',
    styleUrl: './receipt-lookup-results.component.scss'
})
export class ReceiptLookupResultsComponent implements OnInit {
    readonly #receiptSearchService: ReceiptSearchService = inject(ReceiptSearchService);
    readonly #navigation: ReceiptLookupNavigationService = inject(ReceiptLookupNavigationService);

    // Use the signal directly from the service
    receiptResults: WritableSignal<SearchResult> = this.#receiptSearchService.currentResults;

    ngOnInit(): void {
        // Check if we need to load persisted results
        const currentResults: SearchResult = this.#receiptSearchService.getCurrentResults();

        if (!currentResults.data || currentResults.data.length === 0) {
            const persistedResults: SearchResult | null = this.#receiptSearchService.loadPersistedResults();
            if (persistedResults) {
                // Update the service state with persisted results
                this.#receiptSearchService.updateResults(persistedResults);
            }
        }
    }

    navigateBackToLandingPage() {
        this.#navigation.navigateToSearchRoot();
    }
}
